import React, { useRef, useState } from 'react';
import { useWorkshopMode } from '../../stores/WorkshopModeContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const WORKSHOP_MODE_PASSWORD = 'hiddenDino';

const AppHeader = () => {
  const [clicks, setClicks] = useState(0);
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const timer = useRef(null);
  const { toggleWorkshopMode } = useWorkshopMode();

  const handleLogoClick = () => {
    const next = clicks + 1;
    clearTimeout(timer.current);
    if (next >= 3) {
      setClicks(0);
      setPassword('');
      setError(false);
      setPasswordDialogOpen(true);
      return;
    }
    setClicks(next);
    timer.current = setTimeout(() => setClicks(0), 1500);
  };

  const handleDialogOpenChange = (open) => {
    setPasswordDialogOpen(open);
    if (!open) {
      setPassword('');
      setError(false);
    }
  };

  const handleConfirm = () => {
    if (password === WORKSHOP_MODE_PASSWORD) {
      toggleWorkshopMode();
      setPasswordDialogOpen(false);
      setPassword('');
      setError(false);
    } else {
      setError(true);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleConfirm();
    }
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-30 flex items-center h-[71px] px-6"
      style={{ background: 'linear-gradient(to right, #2C65E8, #41CCAB)' }}
    >
      <img
        src="/shape_Logo_final_Designversionen_000_transparent.png"
        alt="Shape Process Intelligence"
        className="h-[40px] ml-[75px] cursor-pointer select-none"
        onClick={handleLogoClick}
      />

      <Dialog open={passwordDialogOpen} onOpenChange={handleDialogOpenChange}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>Enter Password</DialogTitle>
          </DialogHeader>
          <div className="px-6 py-2">
            <Input
              type="password"
              autoFocus
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(false);
              }}
              onKeyDown={handleKeyDown}
              placeholder="Password"
            />
            {error && (
              <p className="mt-2 text-sm text-red-600">Incorrect password.</p>
            )}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => handleDialogOpenChange(false)}>
              Cancel
            </Button>
            <Button onClick={handleConfirm}>Confirm</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AppHeader;
